import { PrismicRichText } from '@prismicio/react';

import React from 'react';
import Link from 'next-translate-routes/link';

import { Button } from '@components/atoms/Button';
import { linkResolver } from '@prismic/prismic-config';
import NoPhoto from 'images/no-photo.svg';
import * as S from './styles';
import { IProps } from './types';

export const ProductBenefit: React.FC<IProps> = ({
  image,
  title,
  label,
  link,
  color,
  overlay,
}: IProps) => (
  <S.Wrapper style={{ backgroundImage: `url(${image.url || NoPhoto})` }}>
    <S.Content className="content">
      <S.Title reverse={color === 'black'} className="title">
        <PrismicRichText field={title} />
      </S.Title>
      {link && (
        <S.Button>
          <Link href={linkResolver(link)} passHref>
            <a>
              <Button size="sm" fullWidth>
                <PrismicRichText field={label} />
              </Button>
            </a>
          </Link>
        </S.Button>
      )}
    </S.Content>
    {overlay && <S.Overlay />}
  </S.Wrapper>
);
